export enum LegTransportTypeEnum {
  Ground = 'Ground',
  Air = 'Air',
}
